module.exports = __webpack_public_path__ + "static/img/bg_tw.1d3f2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_tw.png
// module id = aiOb
// module chunks = 2